import { CLEAR_TALENT_INFO, SET_TALENT_INFO } from '../constants';

//Obtiene toda la informacion relacionada a un talento para mostrarla en la pagina de talentos
export const setTalentInfo = talentId => (dispatch, getState) => {
  const { talentos } = getState().search.searchResults;
  const talentIndex = talentos.findIndex(talent => talent.id === talentId);
  const talentInfo = talentos[talentIndex];

  dispatch({
    type: SET_TALENT_INFO,
    payload: {
      id: talentInfo?.id,
      internalIds: talentInfo?.internal_ids,
      name: `${talentInfo?.first_name} ${
        talentInfo?.last_name !== null ? talentInfo?.last_name : ''
      }`,
      roles: talentInfo?.roles,
      searchRoles: talentInfo?.search_roles,
    },
  });
};

//Purga la informacion del talento
export const clearTalentInfo = () => dispatch => {
  dispatch({
    type: CLEAR_TALENT_INFO,
  });
};
